import { bsc } from 'wagmi/chains';
import { defineChain } from 'viem';
import { http, createStorage, noopStorage } from 'wagmi';
import { getDefaultConfig } from '@rainbow-me/rainbowkit';
import {
  metaMaskWallet,
  trustWallet,
  rainbowWallet,
  walletConnectWallet,
  safeWallet,
  tokenPocketWallet,
  imTokenWallet,
  binanceWallet,
} from '@rainbow-me/rainbowkit/wallets';

export const localhost = defineChain({
  id: 31337,
  name: 'Localhost',
  nativeCurrency: {
    decimals: 18,
    name: 'Ether',
    symbol: 'ETH',
  },
  rpcUrls: {
    default: { http: [import.meta.env.VITE_RPC_URL || 'http://127.0.0.1:8545'] },
  },
});

const storage = createStorage({
  storage: typeof window !== 'undefined' && window.localStorage ? localStorage : noopStorage,
  key: 'wagmi',
});

const getAppUrl = () => {
  if (typeof window !== 'undefined') {
    return window.location.origin;
  }
  return 'https://member.asetquhub.com';
};

const projectId = import.meta.env.VITE_WALLETCONNECT_PROJECT_ID || '';
const appName = 'AsetQu Hub';
const chains = [import.meta.env.MODE === 'development' ? localhost : bsc] as const;

export const config = getDefaultConfig({
  appName,
  projectId,
  chains,
  ssr: false,
  appIcon: `${getAppUrl()}/logo.png`,
  appUrl: getAppUrl(),
  appDescription: 'AsetQu Hub - Revolutionizing Real Estate with Blockchain',
  storage,
  wallets: [
    {
      groupName: 'Recommended',
      wallets: [metaMaskWallet, trustWallet, walletConnectWallet, binanceWallet, safeWallet],
    },
    {
      groupName: 'More Wallets',
      wallets: [rainbowWallet, tokenPocketWallet, imTokenWallet],
    },
  ],
  transports: {
    [import.meta.env.MODE === 'development' ? localhost.id : bsc.id]: http(),
  },
});
